module.exports = __webpack_public_path__ + "img/img2.8fc1002a.jpg";